import { useContext, useLayoutEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { ContextualChatContext } from 'contexts';

const StreamChatRouteHandler: React.FC = () => {
  const { channelId, messageId } = useParams<{
    channelId?: string;
    messageId?: string;
  }>();
  const history = useHistory();
  const { client, setChannel, setChatModalVisible, setHighlightedId, channel } =
    useContext(ContextualChatContext);

  useLayoutEffect(() => {
    if (!client) return;

    const setupChat = async () => {
      setChatModalVisible(true);

      if (!channelId) {
        setChannel(null);
        setHighlightedId('');
        return;
      }

      if (channel?.id === channelId) {
        setHighlightedId(messageId || '');
        return;
      }

      try {
        const channels = await client.queryChannels(
          { id: { $eq: channelId } },
          {},
          { limit: 1 },
        );

        if (channels.length > 0) {
          setChannel(channels[0]);
          setHighlightedId(messageId || '');
        } else {
          console.warn(`Channel with id ${channelId} not found.`);
          setChannel(null);
          setHighlightedId('');
        }
      } catch (error) {
        console.error('Error fetching channel for route:', error);
        setChannel(null);
        setHighlightedId('');
      }
    };

    setupChat();
    history.replace('/my_business');
  }, [channelId, messageId, client]);

  return null;
};

export default StreamChatRouteHandler;
